import type {
  FormattedTimeslot,
  Timeslot
} from '~/terminierungsportal/types/appointmentTypes'

const { formatDate } = useDate()

export const useDateFormatter = () => {
  const formatTimeslots = (
    timeslot: Timeslot,
    preferredTimeslot: Timeslot | null
  ): FormattedTimeslot => {
    const from = preferredTimeslot?.from
      ? preferredTimeslot.from
      : timeslot.from
    const to = preferredTimeslot?.to ? preferredTimeslot.to : timeslot.to
    const day = formatDate(from, 'dd, DD.MM.YYYY')
    const asTime = (date: Date) => formatDate(date, 'HH:mm')
    const time = `${asTime(from)} - ${asTime(to)}`

    return { day, time }
  }

  return { formatTimeslots }
}
